import { render, staticRenderFns } from "./sales-order-so-types.vue?vue&type=template&id=82c81ad8&scoped=true&"
import script from "./js/sales-order-so-types.js?vue&type=script&lang=js&"
export * from "./js/sales-order-so-types.js?vue&type=script&lang=js&"
import style0 from "./sales-order-so-types.vue?vue&type=style&index=0&id=82c81ad8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82c81ad8",
  null
  
)

export default component.exports